import React from 'react'
import Countdown, { zeroPad } from 'react-countdown';

export default function Countdowncomp({ timestamp }) {

    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return (
                <div class="de_countdown is-countdown">
                    <span class="countdown-row countdown-show3">
                        <span class="countdown-section">
                            <span class="countdown-amount">00d</span>
                        </span>
                        <span class="countdown-section">
                            <span class="countdown-amount">00h</span>
                        </span>
                        <span class="countdown-section">
                            <span class="countdown-amount">00m</span>
                        </span>
                        <span class="countdown-section">
                            <span class="countdown-amount">00s</span>
                        </span>
                    </span>
                </div>
            );
        } else {
            // Render a countdown
            return (
                <div class="de_countdown is-countdown">
                    <span class="countdown-row countdown-show3">
                        <span class="countdown-section">
                            <span class="countdown-amount">{zeroPad(days, 2)}d</span>
                        </span>
                        <span class="countdown-section">
                            <span class="countdown-amount">{zeroPad(hours, 2)}h</span>
                        </span>
                        <span class="countdown-section">
                            <span class="countdown-amount">{zeroPad(minutes, 2)}m</span>
                        </span>
                        <span class="countdown-section">
                            <span class="countdown-amount">{zeroPad(seconds, 2)}s</span>
                        </span>
                    </span>
                </div>
            );
        }
    };

    return (
        <Countdown
            date={timestamp * 1000}
            renderer={renderer}
            key={Math.random()}
        />
    )
}
